// extracted by mini-css-extract-plugin
export default {"location-search":"LocationSearch_location-search__dHhgG","options-list":"LocationSearch_options-list__YSMhE"};